/**
 * dayjs 전역 설정 모듈
 *
 * 플러그인 확장과 로케일 설정을 한 곳에서 관리합니다.
 * dayjs를 사용하는 모든 파일은 'dayjs' 대신 이 모듈에서 import 하세요.
 */
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);
dayjs.locale('ko');

export default dayjs;
export type { Dayjs } from 'dayjs';
